import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["id", "arrowPosition", "arrowSize", "containerStyles", "arrowStyles", "children"];
import styled, { css } from 'styled-components';
import memoWithDisplayName from '../../utils/memoWithDisplayName';
import { jsx as _jsx } from "react/jsx-runtime";
const whenAlignment = (alignment, value1, value2) => (ifFirst, ifSecond, otherwise) => alignment === value1 ? ifFirst : alignment === value2 ? ifSecond : otherwise;
const StyledDiv = styled.div.withConfig({
  displayName: "ArrowContainer__StyledDiv",
  componentId: "sc-1wu252m-0"
})(({
  theme: _theme,
  arrowSize,
  arrowPosition,
  arrowStyles,
  containerStyles
}) => {
  const theme = _theme;
  return css(["position:relative;background:", ";padding:0;margin:0;display:block;&::after{content:'';display:block;position:absolute;width:", ";height:", ";background:", ";border-image:initial;clip-path:polygon(100% 100%,0px 100%,100% 0px);border-top-left-radius:100%;", " ", "}", ""], theme.color['fill-surface-default'], arrowSize && `${arrowSize}px`, arrowSize && `${arrowSize}px`, theme.color['fill-surface-default'], () => {
    const [position, alignment] = arrowPosition.split(' ');
    const closeCorner = `calc(10% - ${arrowSize / 2}px)`;
    const farCorner = `calc(90% - ${arrowSize / 2}px)`;
    const center = `calc(50% - ${arrowSize / 2}px)`;
    const centerInverse = `-${arrowSize / 2}px`;
    const whenAlignmentH = whenAlignment(alignment, 'left', 'right');
    const whenAlignmentV = whenAlignment(alignment, 'top', 'bottom');
    switch (position) {
      case 'bottom':
        {
          return {
            bottom: centerInverse,
            transform: 'rotate(45deg)',
            left: whenAlignmentH(closeCorner, farCorner, center)
          };
        }
      case 'top':
        {
          return {
            top: centerInverse,
            transform: 'rotate(-135deg)',
            left: whenAlignmentH(closeCorner, farCorner, center)
          };
        }
      case 'left':
        {
          return {
            left: centerInverse,
            transform: 'rotate(135deg)',
            top: whenAlignmentV(closeCorner, farCorner, center)
          };
        }
      case 'right':
        {
          return {
            right: centerInverse,
            transform: 'rotate(-45deg)',
            top: whenAlignmentV(closeCorner, farCorner, center)
          };
        }
      default:
        break;
    }
  }, arrowStyles || '', containerStyles || '');
});
export const ArrowContainer = memoWithDisplayName('ArrowContainer', _ref => {
  let {
      id,
      arrowPosition = 'top',
      arrowSize = 10,
      containerStyles,
      arrowStyles,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledDiv, Object.assign({
    id: id,
    "data-test-id": id,
    arrowPosition: arrowPosition,
    arrowSize: arrowSize,
    containerStyles: containerStyles,
    arrowStyles: arrowStyles
  }, rest, {
    children: children
  }));
});